import { render, staticRenderFns } from "./LiquidAnalyzer.vue?vue&type=template&id=5a474472&scoped=true&"
import script from "./LiquidAnalyzer.vue?vue&type=script&lang=js&"
export * from "./LiquidAnalyzer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a474472",
  null
  
)

export default component.exports